import { useGetUserNameWithFallback } from '@pba/react-utils';
import type { BaseOptionType } from 'antd/lib/select';
import { useMemo, useState } from 'react';
import { AvatarOption, DebounceSelect, type DebounceSelectProperties } from 'ui';
// TODO: fix this import - 82948
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useUsersQuery } from 'features/users/queries/useUsersQuery';

type Option = { email: string; label: string; profilePhoto?: string; value: string };

type P<ValueType, OptionType extends BaseOptionType> = {
  communityId: string;
  showDetailedOption?: boolean;
} & DebounceSelectProperties<ValueType, OptionType>;

const UsersInput = ({ autoClearSearchValue = false, communityId, showDetailedOption, ...rest }: P<string, Option>) => {
  const [search, setSearch] = useState<string>();
  // TODO: create infinite scroll for users
  const { data: users, isFetching, isLoading } = useUsersQuery({ excludeCommunityId: communityId, limit: 10, search });
  const getUserNameWithFallback = useGetUserNameWithFallback();

  const options = useMemo(
    () =>
      users?.map((user) => ({
        email: user.email,
        label: getUserNameWithFallback(user),
        profilePhoto: user.profilePhoto?.url,
        value: user.id,
      })),
    [getUserNameWithFallback, users],
  );

  return (
    <DebounceSelect<string, Option>
      autoClearSearchValue={autoClearSearchValue}
      filterOption={false}
      loading={isLoading || isFetching}
      mode="multiple"
      onSearch={setSearch}
      optionRender={
        showDetailedOption
          ? (option) => (
              <AvatarOption email={option.data.email} name={option.data.label} src={option.data.profilePhoto} />
            )
          : undefined
      }
      options={options}
      showSearch
      {...rest}
    />
  );
};

export default UsersInput;
